import { isNumber } from 'util';
import { Vue, Component, Watch, Prop, Provide } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import isEmpty from 'lodash/isEmpty';
import type { CreateElement } from '../../../../node_modules/vue';
import Index from './index.vue';
import { IPSService } from '@/services/ipsServices';
import imagePreview from '@/views/components/imgPreview';
import ShopDisplay from '@/views/components/shopDisplaySketchMap/display';
import ShopDisplayEdit from '@/views/components/shopDisplaySketchMap/displayEdit';
import validateParams from '@/library/utils/paramFilter';
import { QinggerLibUtils } from '@/util';
import { Functions } from '@/library/utils/functions';
const isset = QinggerLibUtils.isset;

const PageInfoService = ['miniPageInfo', 'miniPageInfo', 'siteMicroPageInfo'];
const PageTempSaveService = ['miniPageTempSave', 'miniPageTempSave', 'siteMicroPageTempSave'];
const PageSaveService = ['miniPageSave', 'miniPageSave', 'siteMicroPageSave'];
const PagePreviewService = ['miniPagePreview', 'miniPagePreview', 'siteMicroPageConfigDisplay'];
@Component({
  mixins: [Index],
  components: {
    imagePreview,
    ShopDisplay,
    ShopDisplayEdit,
  },
})
export default class EditMiniPage extends Vue {
  @Prop()
    value: boolean;

  @Prop({ default: 0 })
    pageId: number;

  @Prop()
    isDisabled: boolean;

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Prop({ default: 1 })
    mode: number;

  @Prop()
    siteId: number;

  @Prop()
    classList: ItemArray;

  $refs: {
    form: ElForm;
    config: ElForm;
  };

  data: MiniPageEdit = [];

  defaultBg = '#f2f2f2';

  pageName = '';

  miniPage: MiniPageBg = {
    fieldType: 'miniPage',
    isActived: true,
    desc: {
      pageName: '微页面',
      val: '#f2f2f2',
      showButton: true,
      buttonInfo: {
        buttonVal: '#FCCA00',
        textColor: '#000000',
        content: '返回',
        pageInfo: {
          pageId: 0,
          page: 3,
          linkDesc: '',
        },
      },
    },
  };

  activedIndex = -1;

  connectedClass = [];

  // 2 or 3 控制调用微页面接口
  get serviceIndex() {
    return +this.$route.params.siteId ? 2 : 1;
  }

  @Watch('value')
  watchValue(n) {
    this.celerData();
    !n && this.pageId && this.getConfig();
    !n && !this.pageId && this.data.push(this.miniPage);
  }

  @Watch('data', { deep: true })
  watchData(n) {
    this.activedIndex = n.findIndex(v => v.isActived);
  }

  async mounted() {
    this.connectedClass = await this.getAttributeList();
  }

  /**
   * 网点组获取关联分类
   */
  public getAttributeList(): Promise<any> {
    return IPSService.getAttributeList().then((res) => {
      return isset(res, 'list') ? res.list : [];
    });
  }

  celerData() {
    this.data = [];
    this.miniPage = {
      fieldType: 'miniPage',
      isActived: true,
      desc: {
        pageName: '微页面',
        val: '#f2f2f2',
        showButton: true,
        buttonInfo: {
          buttonVal: '#FCCA00',
          textColor: '#000000',
          content: '返回',
          pageInfo: {
            pageId: 0,
            page: 3,
          },
        },
      },
    };
    this.defaultBg = '#f2f2f2';
    this.pageName = '';
  }

  onSave(isPre = 0) {
    if (this.validate().state) {
      const loading = this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(225,225,225,0.3)',
      });
      this.computedPropagateData();
      const postParams = {
        sgId: Number(this.$route.params.id),
        pageId: this.pageId,
        siteId: this.siteId,
        pageName: this.miniPage.desc.pageName,
        val: this.miniPage.desc.val,
        showButton: Number(this.miniPage.desc.showButton),
        list: this.data
          .filter(v => v.fieldType != 'miniPage')
          .map((val, i) => {
            // 暂时处理，去掉商品橱窗多传的字段productList
            if (val.fieldType === 'ShowWindowGroup' || val.fieldType === 'ShowWindow') {
              if (val.desc && (val as DisplayShowWindowGroupData).desc.productList) {
                delete (val as DisplayShowWindowGroupData).desc.productList;
              }
              if (val.desc && (val as DisplayShowWindowGroupData).desc.caseGroup) {
                (val as DisplayShowWindowGroupData).desc.caseGroup = ((val as DisplayShowWindowGroupData).desc.caseGroup || []).map((v) => {
                  if (v.productList) {
                    delete v.productList;
                  }
                  return v;
                });
              }
            }
            val.sort = i + 1;
            return val;
          }),
        buttonInfo: {
          buttonVal: this.miniPage.desc.buttonInfo.buttonVal,
          textColor: this.miniPage.desc.buttonInfo.textColor,
          content: this.miniPage.desc.buttonInfo.content,
          pageInfo: {
            page: this.miniPage.desc.buttonInfo.pageInfo.page,
            pageId: this.miniPage.desc.buttonInfo.pageInfo.pageId,
            isShop: this.siteId ? 0 : 1,
          },
        },
      };
      if (!isPre) {
        IPSService[PageSaveService[this.serviceIndex]]({
          postParams: validateParams(postParams),
        })
          .then((res) => {
            loading.close();
            this.$emit('save');
          })
          .catch((error) => {
            loading.close();
          });
      } else {
        this.preview(validateParams(postParams), loading);
      }
    }
  }

  getInfo(pageId = this.pageId): Promise<any> {
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    return IPSService[PageInfoService[this.serviceIndex]]({
      postParams: {
        pageId,
      },
    })
      .then((response) => {
        loading.close();
        response.list = (response.list || []).map((v) => {
          if (v.fieldType === 'ShowWindow' || v.fieldType === 'ShowWindowGroup') {
            const defaultDesc = {
              caseType: 1,
              caseName: '',
              fontSize: 28,
              style: [],
              caseNum: 4,
              caseGroup: [],
              caseStyle: 1,
              isShowMore: 1,
            };
            v.desc = Object.assign({}, defaultDesc, v.desc);
          }
          return v;
        });
        return response;
      })
      .catch(() => {
        loading.close();
      });
  }

  getConfig() {
    this.getInfo().then((response) => {
      this.miniPage.desc = Object.assign(
        this.miniPage.desc,
        { buttonInfo: isEmpty(response.buttonInfo) ? this.miniPage.desc.buttonInfo : response.buttonInfo },
        {
          showButton: !!response.showButton,
          val: response.val,
          pageName: response.pageName,
        },
      );
      if (this.miniPage.desc.buttonInfo.pageInfo.page === 4 && this.miniPage.desc.buttonInfo.pageInfo.pageId) {
        this.getInfo(this.miniPage.desc.buttonInfo.pageInfo.pageId)
          .then((res) => {
            this.miniPage.desc.buttonInfo.pageInfo.linkDesc = `${res.pageId}+${res.pageName}`;
            this.fillData(response);
          })
          .catch(() => {
            (this.miniPage.desc.buttonInfo.pageInfo.pageId as any) = '';
            this.fillData(response);
          });
      } else if (this.miniPage.desc.buttonInfo.pageInfo.page === 1 && this.miniPage.desc.buttonInfo.pageInfo.pageId) {
        IPSService.newDistributionDetail({
          postParams: {
            policyId: this.miniPage.desc.buttonInfo.pageInfo.pageId,
          },
        })
          .then((result) => {
            this.miniPage.desc.buttonInfo.pageInfo.linkDesc = `${this.miniPage.desc.buttonInfo.pageInfo.pageId}+${result.policyName}`;
            this.fillData(response);
          })
          .catch(() => {
            (this.miniPage.desc.buttonInfo.pageInfo.pageId as any) = '';
            this.fillData(response);
          });
      } else {
        this.fillData(response);
      }
    });
  }

  getDistributionInfo() {}

  fillData(response) {
    this.data.push(this.miniPage);
    const defaultDesc = {
      caseType: 1,
      caseName: '',
      fontSize: 28,
      style: [],
      caseNum: 4,
      caseGroup: [],
      caseStyle: 1,
    };
    const result = response.list.map((v) => {
      if (v.fieldType === 'ShowWindow' || v.fieldType === 'ShowWindowGroup') {
        v.desc = Object.assign({}, defaultDesc, v.desc);
      }
      v = Object.assign({}, v, { isActived: false });
      return v;
    });
    this.data = this.data.concat(result).map((v) => {
      if (v.fieldType === 'LabelClass' && v.desc && (v.desc as LabelClassDesc).list && (v.desc as LabelClassDesc).list.length) {
        (v.desc as LabelClassDesc).list = (v.desc as LabelClassDesc).list.filter(vl => !!vl);
        (v.desc as LabelClassDesc).list = (v.desc as LabelClassDesc).list.map((i) => {
          i.relationList.map((z) => {
            z.selectNames = this.setSelectGoods(z);
            return z;
          });
          return i;
        });
        (v.desc as LabelClassDesc).list = (v.desc as LabelClassDesc).list.filter(vl => vl.isAllClass != 1);
      }

      if (v.fieldType === 'HoverIcon') {
        const miniPage = (v as DisplayHoverIconData).desc.list.filter(v => v.page === 16);
        if (miniPage.length) {
          Promise.all(this.getMiniName(miniPage)).then((result) => {
            result.forEach((r) => {
              (v as DisplayHoverIconData).desc.list.forEach((f) => {
                if (r.pageId === f.pageId) {
                  f.pageName = r.pageName;
                }
              });
            });
          });
        }
      }

      if (v.fieldType === 'iconMenu') {
        const iconLink = (v as DisplayIconMenuData).desc.list.filter(val => val.page === 3 || val.page === 6 || (val.page === 16 && val.pageId));
        if (iconLink.length) {
          Promise.all(this.getMiniName(iconLink)).then((result) => {
            result.forEach((r) => {
              (v as DisplayIconMenuData).desc.list.forEach((f) => {
                if (r.pageId === f.pageId) {
                  f.pageName = r.pageName;
                }
              });
            });
          });
        }
      }
      return v;
    });
    this.defaultBg = response.val;
    this.pageName = response.pageName;
  }

  getMiniName(arr = []): Promise<any>[] {
    arr = arr.filter(v => !!v.pageId);
    return arr.map((v, i) => {
      return IPSService[PageInfoService[this.serviceIndex]]({
        postParams: {
          pageId: v.pageId,
        },
      });
    });
  }

  tempSave() {
    if (this.validate().state) {
      const loading = this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(225,225,225,0.3)',
      });
      this.computedPropagateData();
      IPSService[PageTempSaveService[this.serviceIndex]]({
        postParams: {
          sgId: Number(this.$route.params.id),
          pageId: this.pageId,
          siteId: this.siteId,
          pageName: this.miniPage.desc.pageName,
          val: this.miniPage.desc.val,
          showButton: Number(this.miniPage.desc.showButton),
          list: this.data
            .filter(v => v.fieldType != 'miniPage')
            .map((val, i) => {
              val.sort = i + 1;
              return val;
            }),
          buttonInfo: {
            buttonVal: this.miniPage.desc.buttonInfo.buttonVal || '',
            textColor: this.miniPage.desc.buttonInfo.textColor || '',
            content: this.miniPage.desc.buttonInfo.content || '',
            pageInfo: {
              page: this.miniPage.desc.buttonInfo.pageInfo.page,
              pageId: this.miniPage.desc.buttonInfo.pageInfo.pageId,
              isShop: this.siteId ? 0 : 1,
            },
          },
        },
      })
        .then((res) => {
          this.$message.success('保存成功');
          this.$emit('save', res.pageId);
          loading.close();
        })
        .catch((error) => {
          loading.close();
        });
    }
  }

  computedPropagateData() {
    this.data = this.data.map((i) => {
      if (i.fieldType === 'Propagate') {
        (i.desc as any) = {
          pName: (i.desc as PropagateDesc).pName,
          pWidth: (i.desc as PropagateDesc).pWidth,
          pHeight: (i.desc as PropagateDesc).pHeight,
          pMaxPage: (i.desc as PropagateDesc).pMaxPage,
          pStyle: (i.desc as PropagateDesc).pStyle,
          displayType: (i.desc as PropagateDesc).displayType,
          margin: (i.desc as PropagateDesc).margin,
          borderRadius: (i.desc as PropagateDesc).borderRadius,
          backGround: (i.desc as PropagateDesc).backGround,
          list: (i.desc as PropagateDesc).list,
          config: {
            pStyle: (i.desc as PropagateDesc).pStyle,
            displayType: (i.desc as PropagateDesc).displayType,
            margin: (i.desc as PropagateDesc).margin,
            borderRadius: (i.desc as PropagateDesc).borderRadius,
            backGround: (i.desc as PropagateDesc).backGround,
          },
        };
      }
      return i;
    });
  }

  setSelectGoods(data) {
    if (!data.attrValues) {
      return '';
    }
    const find = this.connectedClass.filter(i => i.list && i.list.length).find(i => i.attrCode === data.attrCode);

    if (find) {
      return find.list
        .filter((v) => {
          return data.attrValues.split(',').includes(v.value_no);
        })
        .map(i => i.value_name);
    }
    return '';
  }

  validate(): { state: boolean; data: MiniPageEdit } {
    const result = { state: false, data: [] };
    const { index, message } = Functions.validateDisplayData(this.data, !!this.siteId);
    if (index + 1) {
      this.data = this.data.map((v) => {
        v.isActived = false;
        return v;
      });
      this.data[index].isActived = true;
      setTimeout(() => {
        if ((this.$refs.config.$refs[this.data[index].fieldType] as ElForm).$refs.form) {
          ((this.$refs.config.$refs[this.data[index].fieldType] as ElForm).$refs.form as ElForm).validate(() => {});
        }
      }, 0);
      this.$nextTick(() => {
        this.$el.querySelector('.is-actived').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      message && this.$message.warning(message);
      return result;
    }
    this.data = this.data.filter((v) => {
      if (v.fieldType === 'text') {
        return ((v as DisplayTextData).desc.title && (v as DisplayTextData).desc.title.trim()) || ((v as DisplayTextData).desc.content && (v as DisplayTextData).desc.content.trim());
      } else {
        return v;
      }
    });
    result.state = true;
    result.data = this.data;
    return result;
  }

  onCancel() {
    this.$confirm('是否取消当前编辑?', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.$emit('cancel');
      }
    });
  }

  preview(postParams, loading) {
    IPSService[PagePreviewService[this.serviceIndex]]({
      postParams: validateParams(postParams),
    })
      .then((res) => {
        loading.close();
        imagePreview.open({ img: res.disPlayUrl }).catch(() => {});
      })
      .catch(() => {
        loading.close();
      });
  }

  render(h: CreateElement) {
    return !this.value ? (
      <div class="mini-page-edit">
        <div class="mini-page-edit-content">
          <div class="flex height-100">
            <div style="height: inherit;">
              <div class="mini-page-map" style="width: 25vw;min-width: 475px">
                <ShopDisplay
                  v-model={this.data}
                  fromPage={this.mode == 1 ? 3 : this.siteId ? 8 : 9}
                  disabled={this.isDisabled}
                  defaultBg={this.miniPage.desc.val}
                  showButton={this.miniPage.desc.showButton}
                  buttonInfo={this.miniPage.desc.buttonInfo}
                />
              </div>
            </div>
            <div class="height-100">
              <ShopDisplayEdit
                attrButeList={this.connectedClass.map((v) => {
                  v.value_name = v.attrName;
                  v.value_no = v.attrCode;
                  v.class_code = v.attrCode;
                  v.isLeafe = !v.list || !v.list.length;
                  return v;
                })}
                key={this.activedIndex}
                v-model={this.data[this.activedIndex]}
                disabled={this.isDisabled}
                siteClassList={this.classList}
                fromPage={this.mode == 1 ? 3 : this.siteId ? 8 : 9}
                ref="config"
              />
            </div>
          </div>
        </div>
        <div class="bottomWrapper">
          {!this.isDisabled && (
            <el-button type="primary" onClick={this.onSave.bind(this, 0)} disabled={this.isDisabled}>
              发布
            </el-button>
          )}
          {/* {!this.pageId && [
            <span class="scopeSpan" onClick={this.tempSave.bind(this)}>
              暂存并继续
            </span>,
          ]} */}
          <div class="scopeSpan" onClick={this.onSave.bind(this, 1)}>
            预览
          </div>
          <div class="scopeSpan" onClick={this.onCancel.bind(this)}>
            取消
          </div>
        </div>
      </div>
    ) : (
      ''
    );
  }
}
